<template>
  <div class="help">
    <tabs>
      <tab :name="$t('help.isThisLegal')" property="is-this-legal" id="1" iconName="pencil" isActive="true">
        <h3>{{ $t('help.isThisLegal') }}</h3>
        <p>{{ $t('help.legalityInfo') }}</p>
      </tab>
      <tab :name="$t('help.whatIsSignable')" property="what-is-signable" id="2" iconName="question">
        <p>{{ $t('help.signableDescription') }}</p>
      </tab>
      <tab :name="$t('help.contactCompany', { companyName: $store.state.clientInfo.company_name })" property="contact-signable-team" id="3" iconName="paper-plane" v-if="$store.getters.config('company_questions_signing') > 0">
        <h3>{{ $t('help.contactCompany', { companyName: $store.state.clientInfo.company_name }) }}</h3>
        <p v-if="!messageSent">{{ $t('help.contactFormInfo', { companyName: $store.state.clientInfo.company_name }) }}</p>
        <form class="help__contact-us" v-if="!messageSent">
          <textarea ref="contact"></textarea>
          <app-button :text="$t('functional.send')" iconName="paper-plane" :action="contact" classList="float-right"></app-button>
        </form>
        <message type="success" v-else>
          <h3>{{ $t('help.messageSent') }}</h3>
          <span>{{ $t('help.responseInfo') }}</span>
        </message>
      </tab>
    </tabs>
    <template slot="modalButtons" slot-scope="props">
      <app-button :text="showModalButtons ? $t('functional.noThanks') : $t('functional.close')" iconName="times" :action="props.close"></app-button>
    </template>
  </div>
</template>

<script>
  import AppButton from '@/components/AppButton';
  import Tabs from '@/components/Tabs';
  import Tab from '@/components/Tab';
  import Message from '@/components/Message';
  import axios from 'axios';
  import qs from 'qs';

  export default {
    name: 'help',
    components: {
      AppButton,
      Tabs,
      Tab,
      Message,
    },
    data() {
      return {
        messageSent: false,
      };
    },
    methods: {
      contact() {
        const textarea = this.$refs.contact.value;
        if (window.IS_PREVIEW) {
          alert(this.$t('help.previewWarning'));
        } else if (textarea.length > 0) {
          const data = {
            message: textarea,
            to: 'sender',
            signature: this.$store.getters.envelopeDetails.signature_fingerprint,
          };
          const encodedData = qs.stringify(data);
          axios.post(`${window.APP_URL}/ajax/contract-send-message.php`, encodedData)
            .then((response) => {
              if (response.data === '') {
                this.messageSent = true;
              }
            });
        } else {
          alert(this.$t('help.enterAMessage'));
        }
      },
    },
  };
</script>

<style lang="sass" scoped>
  @import '~styles/component-utils.sass';
  .help
    line-height: 1.5;
    p
      margin-bottom: 0;
    textarea
      max-width: 100%;
      width: 100%;
      min-height: 150px;
      margin-top: $spacing-small;
      margin-bottom: $spacing-small;
      font-size: inherit;
      font: inherit;
      color: inherit;
</style>



// WEBPACK FOOTER //
// Help.vue?678b9196